/* eslint-disable import/no-anonymous-default-export */
import { Wizard_Mode } from '../../shared/enums'
import { IProtocol, IFile } from '../../shared/interfaces'
import { ProtocolWizardActionTypes, ProtocolWizardReduxState, SET_DOCUMENT_FILE, SET_INITIAL_STATE, SET_STEP_INDEX, PREVIOUS_STEP_INDEX, NEXT_STEP_INDEX, SET_PROTOCOL, ADD_ATTACHMENT, UPDATE_PROTOCOL_WIZARD_STATE, LABEL_DIRECTION_TOGGLE, SET_PROTOCOL_WIZARD_TOUCHED, UPDATE_ATTACHMENT, SET_ATTACHMENTS, SET_SELECTED_PRINTER_NAME, SET_DOCUMENT_SCANNER_LOADER, SET_ATTACHMENT_SCANNER_LOADER } from './types'



const setInitialState = (wizardMode: Wizard_Mode): ProtocolWizardActionTypes => {
    return {
        type: SET_INITIAL_STATE,
        wizardMode: wizardMode
    }
}
const setDocumentFile = (documentFile: IFile | undefined): ProtocolWizardActionTypes => {
    return {
        type: SET_DOCUMENT_FILE,
        documentFile: documentFile
    }
}
const setAttachments = (attachmentsFile: IFile[]): ProtocolWizardActionTypes => {
    return {
        type: SET_ATTACHMENTS,
        attachmentsFile: attachmentsFile
    }
}
const addAttachment = (attachmentFile: IFile): ProtocolWizardActionTypes => {
    return {
        type: ADD_ATTACHMENT,
        attachmentFile: attachmentFile
    }
}
const updateAttachment = (attachmentFile: IFile): ProtocolWizardActionTypes => {
    return {
        type: UPDATE_ATTACHMENT,
        attachmentFile: attachmentFile
    }
}
const setProtocol = (protocol: IProtocol): ProtocolWizardActionTypes => {
    return {
        type: SET_PROTOCOL,
        protocol: protocol
    }
}

const setDocumentScannerLoader = (showDocumentLoader: boolean): ProtocolWizardActionTypes => {
    return {
        type: SET_DOCUMENT_SCANNER_LOADER,
        documentScannerLoader: showDocumentLoader
    }
}

const setAttachmentScannerLoader = (showAttachmentLoader: boolean): ProtocolWizardActionTypes => {
    return {
        type: SET_ATTACHMENT_SCANNER_LOADER,
        attachmentScannerLoader: showAttachmentLoader
    }
}

const setSelectedPrinterName = (selectedPrinterName: string): ProtocolWizardActionTypes => {
    return {
        type: SET_SELECTED_PRINTER_NAME,
        selectedPrinterName: selectedPrinterName
    }
}

const updateProtocolWizardState = (newState: Partial<ProtocolWizardReduxState>): ProtocolWizardActionTypes => {
    return {
        type: UPDATE_PROTOCOL_WIZARD_STATE,
        payload: newState
    }
}
const setProtocolWizardTouched = (): ProtocolWizardActionTypes => {
    return {
        type: SET_PROTOCOL_WIZARD_TOUCHED,
    }
}
const setStepIndex = (stepIndex: number): ProtocolWizardActionTypes => {
    return {
        type: SET_STEP_INDEX,
        stepIndex: stepIndex
    }
}
const nextStepIndex = (): ProtocolWizardActionTypes => {
    return {
        type: NEXT_STEP_INDEX,
    }
}
const previousStepIndex = (): ProtocolWizardActionTypes => {
    return {
        type: PREVIOUS_STEP_INDEX,
    }
}

const labelDirectionToggle = (): ProtocolWizardActionTypes => {
    return {
        type: LABEL_DIRECTION_TOGGLE,
    }
}

export default {
    setInitialState,
    setDocumentFile,
    setAttachments,
    addAttachment,
    updateAttachment,
    setProtocol,
    setSelectedPrinterName,
    updateProtocolWizardState,
    setProtocolWizardTouched,
    setStepIndex,
    nextStepIndex,
    previousStepIndex,
    labelDirectionToggle,
    setDocumentScannerLoader,
    setAttachmentScannerLoader
}